export default "__VITE_ASSET__BymiNp8___"